import { render, staticRenderFns } from "./TJ-Checkbox.vue?vue&type=template&id=378a0e60&scoped=true&"
import script from "./TJ-Checkbox.vue?vue&type=script&lang=js&"
export * from "./TJ-Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./TJ-Checkbox.vue?vue&type=style&index=0&id=378a0e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a0e60",
  null
  
)

export default component.exports